export interface RoadmapData {
  id: number;
  img: string;
  title: string;
  list: string[];
}

const data: RoadmapData[] = [
  {
    id: 1,
    img: require('images/roadmap/item-1.png'),
    title: 'Q2.2022',
    list: [
      "Seed and Private Backers and Partners Onboarding",
      "MVP- GSPArena P2P version - DAO based",
      "IDO launch of $GSP token",
      "Launch of GSP Staking Pools - Vote Escrow",
      "Distribution model GSPMetaverse Initial prototyping"
    ]
  },
  {
    id: 2,
    img: require('images/roadmap/item-2.png'),
    title: 'Q3.2022',
    list: [
      "CEX listing of $GSP token",
      "Launch DAO app and snapshot spaces",
      "Audit of GSParena smart contracts",
      "GSPMetaverse architecture and development (Marketplace,Arena)",
      "Testnet launch-GSPArenav1-Dao based"
    ]
  },
  {
    id: 3,
    img: require('images/roadmap/item-3.png'),
    title: 'Q4.2022',
    list: [
      "Mainnet launch-GSPArenav1-Dao based",
      "Add support to top three games and 10 match templates on GSPArena",
      "Referral program for esports, teams, streamers, influencers, etc",
      "Testnet launch-GSPtreams dapp-P2P streaming with light-nodes",
      "GSPMetaverse Layer 1 Launch for Marketplace and Arena on Ethereum"
    ]
  },
  {
    id: 4,
    img: require('images/roadmap/item-4.png'),
    title: 'Q1.2023',
    list: [
      "Mainnet launch-GSPstreams dapp-P2P streaming with light-nodes",
      "Integration with top 3 distribution partners-in-game match oracles",
      "Onboarding top 10 popular games, 50 popular stramers/esport teams",
      "$GSP token buy back and burn program",
      "GSPMetaverse v2 development (Streamcenter, GSP Plaza)"
    ]
  },
  {
    id: 5,
    img: require('images/roadmap/item-5.png'),
    title: 'Q2.2023',
    list: [
      "Launch GSPArena v2-with automated in-game decision making",
      "Launch protocol revenue tracking dashboard",
      "GSP Metaverse v2 Launch"
    ]
  },
  {
    id: 6,
    img: require('images/roadmap/item-6.png'),
    title: 'Q3.2023',
    list: [
      "GSPstreams-guardian nodes launch",
      "Launch protocol on a 2-layer blockchain",
      "Launch 1st mass-scale GSParena tournament with prizes upto 1m usd in the GSPMetaverse"
    ]
  }
];
export default data;